export default __webpack_public_path__ + "static/media/chart_0@3x.38c2fbe9.png";